// Lipoguard-Geraeteliste fuer /zuhause/lipoguard + /zuhause/sensoren
// (History page-lokal).
//
// Datenfluss: kein eigener Abruf mehr -- die Liste kommt aus dem gemeinsamen
// Sensoren-Stand (lib/sensoren.svelte.ts), den das Homelab-Protokoll (Topic
// sensor.stand, docs/protokoll.md › „Sensoren über das Protokoll“) speist.
// REST nur beim Start, als Revalidator, nach Aktionen und als Neuversuch --
// dort. Bis 02.11.2026 holte dieser Store alle 30 s (und bei jedem WS-Signal
// "lipoguard") GET /v2-api/lipoguard.

import { getLipoGeraete, refreshSensoren, startSensoren } from "./sensoren.svelte";
import type { LipoguardDevice } from "./types";

let _aus: (() => void) | undefined;

export function startLipoguardSummary(): void {
  if (_aus) return;
  _aus = startSensoren();
}

export function stopLipoguardSummary(): void {
  _aus?.();
  _aus = undefined;
}

export function getLipoguardSummary(): LipoguardDevice[] | undefined {
  return getLipoGeraete();
}

export async function refreshLipoguardSummary(): Promise<void> {
  await refreshSensoren("lipo");
}
